﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const OperationalContextClient_1 = require("./swagger/OperationalContextClient");
class OperatorClient {
    constructor() {
        this.client = new OperationalContextClient_1.OperationalContextClient();
    }
    getAll() {
        return this.client.apiOperatorsGet();
    }
    get(id) {
        return this.client.apiOperatorsByIdGet(id);
    }
    create(data) {
        return this.client.apiOperatorsPost(data);
    }
    delete(data) {
        return this.client.apiOperatorsDelete(data);
    }
    update(id, data) {
        return this.client.apiOperatorsByIdPut(id, data);
    }
}
exports.OperatorClient = OperatorClient;
//# sourceMappingURL=OperatorClient.js.map